export const getOwnerSVGElement = (element: SVGElement) => element && element.ownerSVGElement;
